import React, {useEffect, useState} from "react";
import {Autocomplete, Button, Grid2 as Grid, TextField, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {ApiKeyOverview} from "../components/apikeys/Overview";
import Creation from "../components/apikeys/Creation";
import useApiKeysClient from "../hooks/UseApiKeysClient";
import {ApiKey, Organization} from "../clients/ApiKeysClient";
import useOrganizations from "../hooks/UseOrganizations";
import {createFilterOptions} from "@mui/material/Autocomplete";
import {Instructions} from "../components/apikeys/Instructions";
import Container from "@mui/material/Container";


export default function ApiKeys() {
  const {t} = useTranslation();
  const [openCreationDialog, setOpenCreationDialog] = useState(false);
  const [org, setOrg] = useState<Organization | null>(null);
  const apiKeysClient = useApiKeysClient();
  const organizations = useOrganizations();

  const [loading, setLoading] = useState(false);
  const [apiKeys, setApiKeys] = useState<ApiKey[]>([]);

  const loadApiKeys = () => {
    if (!org) return;
    setLoading(true);
    apiKeysClient.fetchApiKeys(org.id).then(apiKeys => {
      setApiKeys(apiKeys);
      setLoading(false);
    });
  };

  useEffect(loadApiKeys, [apiKeysClient, org]);
  useEffect(() => {
    organizations.length && setOrg(o => o || organizations[0]);
  }, [organizations]);

  const handleCreationClose = () => {
    setOpenCreationDialog(false);
    loadApiKeys();
  };

  return (<Container sx={{backgroundColor: "white", marginTop: 5, padding: 2}}>
    <Grid container spacing={2} alignItems="center">
      <title>Counter API (SUSHI) - Thieme Counter Reporting</title>

      <Grid size={12}>
        <Typography variant="h2">Instructions</Typography>
        <Instructions />
      </Grid>

      <Grid size={{xs:12, md: 6}} >
        <Typography variant="h2">Manage API Keys</Typography>
      </Grid>

      <Grid size={{xs:12, md: 3}}>
        <Autocomplete
          fullWidth
          options={organizations}
          value={org}
          filterOptions={createFilterOptions({limit: 100})}
          getOptionLabel={o => `${o.name} (${o.id})`}
          onChange={(e, v) => setOrg(v)}
          renderInput={(params) => <TextField {...params} label={t("apikeys.organizationSelectLabel")} />} />
      </Grid>

      <Grid size={{xs:12, md: 3}} justifyContent="flex-end" alignItems="flex-end" alignContent="end">
        <Button size="large" fullWidth variant="contained"
                onClick={() => setOpenCreationDialog(true)}>{t("apikeys.createButtonText")}</Button>
        <Creation open={openCreationDialog} onClose={handleCreationClose} />
      </Grid>

      <Grid size={12} style={{paddingTop: 40}}>
        <ApiKeyOverview apiKeys={apiKeys} onDelete={loadApiKeys} loading={loading}></ApiKeyOverview>
      </Grid>
    </Grid>
  </Container>);
}
